import React from 'react';

import { tpoPartTestId } from '../../../../config/testIds';

const INPUT_CLASS =
    'h-7 px-2 text-sm border rounded focus:outline-none focus:border-[#44338a] border-[#d9d9d9]';
const INVALID_CLASS = 'h-7 px-2 text-sm border rounded focus:outline-none border-[#ff4d4f]';

const toValue = (raw: string): number | null => (raw === '' ? null : Number(raw));

interface RangeInputCellProps {
    minVal: number | null;
    maxVal: number | null;
    invalid: boolean;
    onMinChange: (val: number | null) => void;
    onMaxChange: (val: number | null) => void;
    /** Id of the cell these inputs sit in; the two halves derive from it. */
    testId: string;
}

export const RangeInputCell: React.FC<RangeInputCellProps> = ({
    minVal,
    maxVal,
    invalid,
    onMinChange,
    onMaxChange,
    testId,
}) => (
    <div className="flex items-center gap-1.5">
        <input
            type="number"
            placeholder="Min"
            value={minVal ?? ''}
            onChange={(e) => onMinChange(toValue(e.target.value))}
            className={`w-[100px] ${invalid ? INVALID_CLASS : INPUT_CLASS}`}
            data-testid={tpoPartTestId(testId, 'min')}
            data-state-invalid={invalid ? 'true' : undefined}
        />
        <span className="text-[#d9d9d9] select-none">-</span>
        <input
            type="number"
            placeholder="Max"
            value={maxVal ?? ''}
            onChange={(e) => onMaxChange(toValue(e.target.value))}
            className={`w-[100px] ${invalid ? INVALID_CLASS : INPUT_CLASS}`}
            data-testid={tpoPartTestId(testId, 'max')}
            data-state-invalid={invalid ? 'true' : undefined}
        />
    </div>
);

RangeInputCell.displayName = 'RangeInputCell';

interface NumberInputCellProps {
    value: number | null;
    invalid: boolean;
    onChange: (val: number | null) => void;
    testId: string;
}

export const NumberInputCell: React.FC<NumberInputCellProps> = ({ value, invalid, onChange, testId }) => (
    <input
        type="number"
        placeholder="Default"
        value={value ?? ''}
        onChange={(e) => onChange(toValue(e.target.value))}
        className={`w-[140px] ${invalid ? INVALID_CLASS : INPUT_CLASS}`}
        data-testid={tpoPartTestId(testId, 'value')}
        data-state-invalid={invalid ? 'true' : undefined}
    />
);

NumberInputCell.displayName = 'NumberInputCell';
